<template>
  <div>
    <v-container>
      <v-row>
        <v-col :cols="12">
          <v-text-field :label="'Supplier Name / Company'"
           v-model="name"></v-text-field>
        </v-col>

        <v-col :cols="12">
          <v-text-field :label="'Contact Person'"
           v-model="contactPerson"></v-text-field>
        </v-col>

        <v-col :cols="12">
          <v-text-field
            :label="'Phone'"
            v-model="phone"
          ></v-text-field>
        </v-col>
      </v-row>
      <v-row>
        <v-col :cols="12">
          <v-text-field :label="'Email'"
           v-model="email"></v-text-field>
        </v-col>

        <v-col :cols="12">
          <v-text-field :label="'Address'"
           v-model="address"></v-text-field>
        </v-col>

        <v-col :cols="12">
          <v-text-field
            :label="'City'"
            v-model="city"
          ></v-text-field>
        </v-col>
      </v-row>
    </v-container>

    <v-container>
      <v-row>
        <v-col :cols="5">
          <v-text-field
            :label="'Postal Code'"
            v-model="code"
          ></v-text-field>
        </v-col>
        <v-col :cols="5">
          <v-btn
          dark
            rounded
            color="teal"
            small
            @click="createSupplier()"
            ><v-icon left>mdi-check</v-icon>Create Supplier</v-btn
          >
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import productsAndServicesJs from "@/plugins/productsAndServices"


export default {
  
  computed: {
    getAccessToken() {
      return this.$store.getters.getAccessToken;
    },
  },
  data: () => ({
    name: null,
    contactPerson: 'Manager',
    phone: null,
    code: 4001,
    email: 'supplier@gmail.com',
    address: '123 City Street',
    city:'Durban'
  }),
  methods: {
    async createSupplier() {
      if(this.name && this.phone && this.contactPerson){
      this.$store.commit("setLoader", true);

      const supplier = await productsAndServicesJs.saveSupplier(this.name,this.contactPerson,this.email,this.address, this.phone,this.city,this.code)
       
          if (supplier == "exist") {
            this.$emit("exist", "Supplier Exist");
          } else {
            this.$emit("supplier-created", supplier);
            this.$store.commit("setLoader", false);
            this.$toast.success('Supplier Created Successfully!',{duration:3000})
          }
        
      }else{
        alert('Fill in at least Name, Contact Person, Phone')
      }
    }
  },
};
</script>

<style></style>
